import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ChevronDown } from "@air/next-icons";
import { input } from "@air/primitive-input";
import { memo } from "react";
import { useCardSizePreference } from "~/hooks/useCardSizePreference";
const cardSizes = [
    {
        label: "Small",
        value: "small"
    },
    {
        label: "Medium",
        value: "medium"
    },
    {
        label: "Large",
        value: "large"
    },
    {
        label: "Extra Large",
        value: "extra-large"
    }
];
export const ViewCardSizePreference = /*#__PURE__*/ memo(()=>{
    const { cardSize, updateCardSize } = useCardSizePreference();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center justify-between gap-6 px-2 py-1",
            children: [
                /*#__PURE__*/ _jsx("label", {
                    className: "text-14 text-grey-12",
                    htmlFor: "preferences",
                    children: "Size"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: input({
                        className: "relative px-0 text-12",
                        size: "small"
                    }),
                    children: [
                        /*#__PURE__*/ _jsx("select", {
                            id: "cardSize",
                            defaultValue: cardSize,
                            className: "size-full cursor-pointer appearance-none bg-transparent pl-2 pr-8",
                            onChange: (event)=>{
                                updateCardSize(event.target.value);
                            },
                            value: cardSize,
                            children: cardSizes.map((param)=>{
                                let { value, label } = param;
                                return /*#__PURE__*/ _jsx("option", {
                                    value: value,
                                    children: label
                                }, value);
                            })
                        }),
                        /*#__PURE__*/ _jsx(ChevronDown, {
                            className: "pointer-events-none absolute right-2 top-1/2 size-4 -translate-y-1/2"
                        })
                    ]
                })
            ]
        })
    });
});
ViewCardSizePreference.displayName = "ViewCardSizePreference";
